import React, { FC } from "react";
import { Link, LinkProps } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import styled from "@emotion/styled";
import { useMeQuery } from "api";
import { DEFAULT_AVATAR } from "config";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Avatar from "components/Avatar";
import { getIsRingVisible } from "utills";

const SideMenuProfile: FC<Omit<LinkProps, "to">> = ({ ...rest }) => {
    const { data } = useMeQuery();
    return (
        <CustomLink to={`/profile/${data?.me?.username}`} {...rest}>
            <Avatar
                src={data?.me?.avatar?.LowResUri || DEFAULT_AVATAR}
                hasRing={getIsRingVisible(data?.me?.membershipLevel)}
            />
            <Typography variant="h6">{`${data?.me?.firstName} ${data?.me?.lastName}`}</Typography>
            <Typography variant="caption" sx={{ fontSize: 12 }}>@{data?.me?.username}</Typography>
            <Button
                endIcon={<KeyboardArrowRightIcon />}
                color="primary"
                disableElevation
                disableRipple
                disableFocusRipple
                disableTouchRipple
                sx={{
                    justifyContent: "space-between",
                    marginLeft: "-8px",
                    fontSize: "12px"
                }}
            >View Profile</Button>
        </CustomLink >
    );
};

export default SideMenuProfile;

const CustomLink = styled(Link)`
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 0 0 15px;
    .MuiAvatar-root {
        height: 60px;
        width: 60px;
        background-color: #fff;
    }
    .MuiTypography-h6  {
        font-size: 0.875rem;
        margin-top: 8px;
        font-weight: bold;
        text-transform: capitalize;
    }
`;